import React from "react";
import { Col, Row, Select } from "antd";
import { Controller } from "react-hook-form";
import CustomTextfield from "../../../../../../common/input/custom-textfield/custom-textfield";
import CustomSelect from "../../../../../../common/input/custom-select/custom-select";
import { gendersList, STUDENT_INSTITUTION_TYPE, YES_NO_QUESTIONS } from "../../../../../../constants/common";
import CustomDatepicker from "../../../../../../common/input/custom-datepicker/custom-datepicker";
import CustomUpload from "../../../../../../common/CustomUpload/CustomUpload";
import { useSelector } from "react-redux";
import { checkMixedSchool } from "../../../../../../utils/common";

const StudentInformation = ({ control }) => {
  const user = useSelector((state) => state.user?.user);
  const isMixedSchool = checkMixedSchool(user);

  return (
    <Row gutter={[32, 20]}>
      <Col span={12}>
        <Controller
          name="first_name"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="first_name"
              label="Student First Name"
              showRequired
              labelColor="#171717"
              placeholder="Enter first name"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="middle_name"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="middle_name"
              label="Student Middle Name"
              showOptional
              labelColor="#171717"
              placeholder="Enter middle name"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="last_name"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="last_name"
              label="Student Last Name"
              showRequired
              labelColor="#171717"
              placeholder="Enter last name"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="gender"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomSelect
              id="gender"
              label="Select Gender"
              showRequired
              labelColor="#171717"
              placeholder="--Select--"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            >
              {gendersList?.map((item, index) => (
                <Select.Option key={index} value={item?.value}>
                  {item?.label}
                </Select.Option>
              ))}
            </CustomSelect>
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="date_of_birth"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomDatepicker
              id="date_of_birth"
              label="Date Of Birth"
              showRequired
              labelColor="#171717"
              placeholder="DD-MM-YYYY"
              size="large"
              value={value}
              onChange={onChange}
              style={{ height: "40px", width: "100%" }}
              status={error ? "error" : ""}
              prefix={
                <img
                  src="/assets/images/calendarOutlined.svg"
                  style={{ marginRight: 4 }}
                  alt="calendar"
                />
              }
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="nationality"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="nationality"
              label="Nationality"
              showOptional
              labelColor="#171717"
              placeholder="Enter nationality"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="national_id_number"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="national_id_number"
              label="National ID/Birth Certificate Number"
              showOptional
              labelColor="#171717"
              placeholder="Enter Nation ID Number"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="profile_picture"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomUpload
              accepts=".jpg, .png, .jpeg"
              error={error}
              fileName={value?.name}
              handleBeforeUpload={(file) => {
                onChange(file);
                return false;
              }}
              label="Upload Passport-sized Photo"
              showOptional
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="birth_certificate"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomUpload
              accepts=".jpg, .png, .jpeg, .pdf"
              error={error}
              fileName={value?.name}
              handleBeforeUpload={(file) => {
                onChange(file);
                return false;
              }}
              label="Upload Birth Certificate"
              showOptional
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="beam_student"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomSelect
              id="beam_student"
              label="BEAM Student"
              showOptional
              labelColor="#171717"
              placeholder="--Select--"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            >
              {YES_NO_QUESTIONS?.map((item, index) => (
                <Select.Option key={index} value={item?.value}>
                  {item?.label}
                </Select.Option>
              ))}
            </CustomSelect>
          )}
        />
      </Col>

      {isMixedSchool ? (
        <Col span={12}>
          <Controller
            name="student_institution_type"
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <CustomSelect
                id="student_institution_type"
                label="Day / Boarding"
                showRequired
                labelColor="#171717"
                placeholder="--Select--"
                size="large"
                value={value}
                onChange={onChange}
                status={error ? "error" : ""}
              >
                {STUDENT_INSTITUTION_TYPE?.map((item, index) => (
                  <Select.Option key={index} value={item?.value}>
                    {item?.label}
                  </Select.Option>
                ))}
              </CustomSelect>
            )}
          />
        </Col>
      ) : null}
    </Row>
  );
};

export default StudentInformation;
